<template>
  <div id="contact-associated-companies" class="block">
    <Spin v-if="loading" fix size="small"></Spin>
    <div style="text-align: center" v-if="companies.length === 0">
      <span>No Companies Associated</span>
    </div>
    <ul v-else>
      <h3>Associated Companies</h3>
      <li v-for="(company, index) in companies" :key="index">
        <a href="#">{{ company.name }}</a>
        <template>
          <Icon class="dissociate-company-icon" v-if="company && company.id" type="ios-close" @click="deleteModal = true" />
          <Modal v-model="deleteModal" width="360">
            <p slot="header" style="color:#f60;text-align:center">
              <Icon type="ios-information-circle" style="margin-right: 10px;"></Icon>
              <span>
                {{ $t('contact.associated_company.remove_modal.title') }}
              </span>
            </p>
            <div style="text-align:center">
              <p>
                {{ $t('contact.associated_company.remove_modal.warning') }}
              </p>
              <br>
              <p>
                {{ $t('contact.associated_company.remove_modal.confirm') }}
              </p>
            </div>
            <div slot="footer">
              <Button type="error" size="large" long :loading="deleteModalLoading" @click="handleDissociateCompany(company.id)">
                {{ $t('contact.associated_company.remove_modal.button_text') }}
              </Button>
            </div>
          </Modal>
        </template>
      </li>
    </ul>
    <div class="margin-top-20">
      <CompanySelect v-if="showCompanySelect" @input="handleCompanySelect"></CompanySelect>
    </div>
    <div class="text-align-right margin-top-20">
      <router-link to="#" @click.native="displayCompanySelect">
        Attach company
      </router-link>
    </div>
  </div>
</template>

<script>
import { CompanySelect } from '@/view/companies/components'
import { mapActions } from 'vuex'

export default {
  name: "ContactAssociatedCompany",
  components: {
    CompanySelect
  },
  props: {
    contact: {
      type: Object
    }
  },
  computed: {
    contactId () {
      return this.contact.id
    },
    companies () {
      return this.contact ? this.contact.companies : []
    }
  },
  data () {
    return {
      showCompanySelect: false,
      deleteModal: false,
      loading: false,
      deleteModalLoading: false
    }
  },
  methods: {
    ...mapActions([
      'attachDetachCompany'
    ]),
    displayCompanySelect () {
      this.showCompanySelect = true
    },
    handleCompanySelect (selectedCompany) {
      if (selectedCompany) {
        const data = { companyId: selectedCompany, action: 'attach' }
        this.loading = true
        this.attachDetachCompany({ contactId: this.contact.id, data }).then((resp) => {
          this.$Message.success('Company associated successfully')
          this.$emit('company-updated', resp.data)
        }).finally(() => {
          this.loading = false
          this.showCompanySelect = false
        })
      }
    },
    handleDissociateCompany (company) {
      if (company) {
        const data = { companyId: company, action: 'detach' }
        this.loading = true
        this.deleteModalLoading = true
        this.attachDetachCompany({ contactId: this.contact.id, data }).then((resp) => {
          this.$Message.success('Company dissociated successfully')
          this.$emit('company-updated', resp.data)
        }).finally(() => {
          this.loading = false
          this.deleteModal = false
          this.deleteModalLoading = false
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .dissociate-company-icon{
    float: right;
    font-weight: 700;
    background: #dcdee2;
    text-align: center;
    border-radius: 50%;
    cursor: pointer;
  }
</style>
